var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirportLogoMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7295_10947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 10.6667V9.33337L9.00004 6.00004V2.33337C9.00004 1.78004 8.55337 1.33337 8.00004 1.33337C7.44671 1.33337 7.00004 1.78004 7.00004 2.33337V6.00004L1.33337 9.33337V10.6667L7.00004 9.00004V12.6667L5.33337 13.6667V14.6667L8.00004 14L10.6667 14.6667V13.6667L9.00004 12.6667V9.00004L14.6667 10.6667Z",
    fill: "#DBBE78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7295_10947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportLogoMaps);
export default __webpack_public_path__ + "static/media/airport-logo-maps.ac2b9f5a8f31965df4fb88c2337b95b7.svg";
export { ForwardRef as ReactComponent };